import { Routes } from '@angular/router';
import {AuthorsTableComponent} from "./pages/authors-table/authors-table.component";
import {AuthorPublicationsListComponent} from "./pages/author-publications-list/author-publications-list.component";

export const routes: Routes = [
  { path: 'authorsList', component: AuthorsTableComponent },
  { path: 'list', component: AuthorPublicationsListComponent },
  { path: 'list/:aid', component: AuthorPublicationsListComponent },
  { path: 'author', component: AuthorPublicationsListComponent },
  { path: 'author/:authorShortName', component: AuthorPublicationsListComponent },
  { path: '**', redirectTo: 'authorsList' }
];
